import {GroupData} from '@/types/group';
import {Subject} from 'rxjs';

type GroupChangeData =
  | {
      type: 'change';
      data: GroupData;
    }
  | {
      type: 'new';
      data: GroupData;
    }
  | {
      type: 'deleted';
      id: string;
    };

const groupChangeSubject = new Subject<GroupChangeData>();

export const groupChangeObservable = groupChangeSubject.asObservable();

export const emitGroupChangeEvent = (data: GroupChangeData): void => {
  groupChangeSubject.next(data);
};
